// //comments -info
// import { Injectable }   from '@angular/core';
// import * as english     from "./assets/language/english/english.json";
// import * as spanish     from "./assets/language/spanish/spanish.json";

// @Injectable()
// export class Language {
//     public lang = [{
//         "identifier" : "EN",
//         "name" : "English",
//         "sentences": {
//             "LOGIN": "Login",
//             "REGISTER": "Register",
//             "CONF_PASS": "Confirm Password",
//             "CANCEL": "Cancel",
//             "SIGNUPTEXT": "We are making awesome insurance. Could we take care of you too?",
//             "FOOTER_TEXT": "MAPFRE Insurance is a brand and service of MAPFRE U.S.A Corp. and its affiliates. Learn about",
//             "OUR_COMPANIES": "Our Companies",
//             "PRIVACY": "Privacy Policy",
//             "TERMS": "Terms & Conditions",
//             "QUOTE": "Quote Disclosure",
//             "CAREERS": "Careers",
//             "CONTACT": "Contact",
//             "RIGHTS": "MAPFRE U.S.A Corp. All rights reserved.",
//             "EMAIL_REQUIRED": "Email is required.",
//             "EMAIL_INVALID": "Email is invalid.",
//             "PASSWORD_REQUIRED": "Password is required.",
//             "CONF_PASS_REQUIRED": "Confirm Password is required.",
//             "PASSWORDS_NOT_MATCH": "Password and confirm password does not match.",
//             "FIRST_TIME": "First Time",
//             "SIGN_IN": "Sign In",
//             "CUSTOMER_ACCESS": "Customer Access",
//             "REMEMBER_ME": "Remember Me",
//             "FORGOT_PASS": "Forgot Password",
//             "CREATE_ACCOUNT": "Create Account",
//             "SHOW_PASSWORD": "Show Password",
//             "HIDE_PASSWORD": "Hide Password",
//             "YOUR_PASSWORD_SHOULD_BE": "Your Password Should",
//             "DOES_NOT_PASS": "Does Not Pass",
//             "PASSES_THE_RULE": "Passes the Rule",
//             "INVALID_USERNAME_PASSWORD": "Invalid Username and/or Password",
//             "MODAL_HELP_TITLE": "Help",
//             "MODAL_HELP_CUSTOMER_PORTAL": "Your MAPFRE Account allows you to access your policy documents, report claims, and make payments any time.",
//             "MODAL_HELP_TROUBLE_ACCESSING": "Trouble accessing your account?",
//             "MODAL_HELP_DONT_HESITATE": "Please don’t hesitate to contact our Customer Service Department.",
//             "MODAL_USER_LANGUAGE_TITLE": "LANGUAGE",
//             "CALL_US": "Call Us",
//             "EMAIL_US": "Email Us",
//             "FOOTER_DEFAULT_LANGUAGE": "ENGLISH",
//             "FOOTER_COPY_RIGHT": "MAPFRE U.S.A Corp. All rights reserved.",
//             "FORGOT_PASSWORD_TITLE": "Forgot your password",
//             "FORGOT_PASSWORD_PARAGRAPH": "We'll send you an email with instructions",
//             "FORGOT_PASSWORD_SUBMIT_BUTTON": "Request new Password",
//             "CHECK_YOUR_EMAIL_TITLE": "Check Your Email",
//             "CHECK_YOUR_EMAIL_PARAGRAPH": "We sent an email containing instructions on how to create a new password",
//             "EMAIL": "Email",
//             "PASSWORD": "Password",
//             "VALID_EMAIL_VALIDATION_MESSAGE": "Please Enter A Valid Email",
//             "EMAIL_COULD_NOT_VALIDATE": "We could not validate your email",
//             "INVALID_EMAIL_PASSWORD": "Invalid Email/Password",
//             "CAPS_LOCK": "Caps Lock is On",
//             "FORGOT_EMAIL_CONFIMATION_SUBTITLE": "Didn't receive the email?",
//             "FORGOT_EMAIL_CONFIMATION_COPY": "Check your spam for a message with the subject:",
//             "FORGOT_EMAIL_SUBJECT_LINE": "MAPFRE Insurance - IMPORTANT - Reset your password",
//             "FORGOT_EMAIL_SEND_AGAIN": "Send email again",
//             "FORGOT_EMAIL_REVIEW_ME": "Please Review",
//             "CREATE_PASSWORD": "Type your new password",
//             "CREATE_NEW_PASSWORD": "Create New Password",
//             "VALID_PASSWORD_VALIDATION_MESSAGE": "",
//             "PASSWORD_RESET_CONFIRMATION_PARGRAPH": "Your password was reset",
//             "PASSWORD_RESET_CONFIRMATION_TITLE": "Confirmation",
//             "LINK_HAS_EXPIRED": "Link has expired",
//             "LINK_HAS_EXPIRED_PARAGRAPH": "For security reasons, these links expire after 48 hours.",
//             "REQUEST_NEW_LINK": "Request a new link",
//             "TOO_MANY_ATTEMPTS_TITLE": "Too many attempts",
//             "TOO_MANY_ATTEMPTS_PARAGRAPH": "You have reached the maximum attemps for that email. For security reasons we have blocked that email to continue with this action for the next",
//             "TIME": "24 hours",
//             "FIRST_NAME": "First Name",
//             "MIDDLE_INITIAL": "MI",
//             "LAST_NAME": "Last Name",
//             "CONTINUE": "Continue",
//             "ALL_READY_IN_USE": "is already in use",
//             "IF_YOU_DONT_REMEMBER": "If you don't remember creating an account, contact our Customer Service Department",
//             "NEW_PASSWORD": "Set New Password",
//             "ADD_POLICY_TITLE": "Let's find your policy",
//             "POLICY_NUMBER": "Enter policy number",
//             "I_AM_THE_POLICY_HOLDER": "I am the policy holder or an authorized person",
//             "ADD_POLICY": "Add Policy",
//             "MODAL_WHERE_CAN_I_LINK": "Where can I find my policy number?",
//             "MODAL_WHERE_CAN_I_TITLE": "Locate your policy number",
//             "POLICY_DOCUMENT": "Policy Document",
//             "BILLING_DOCUMENT": "Billing Invoice",
//             "BOP": "Business policy detected",
//             "SERVICE_NOT_AVAILABLE": "This service is currently unavailable.",
//             "BOP_POLICIES_CANNOT_BE_ACCESS_VIA_CUSTOMER_PORTAL": "Business policies cannot currently be accessed via the Customer Portal.",
//             "VERIFY_ACCOUNT_TITLE": "Let's verify your account",
//             "VERIFY_ACCOUNT_WE_SENT_AN_EMAIL": "We sent an email with a verification link to:",
//             "VERIFY_ACCOUNT_SUBJECT_LINE": "Mapfre Insurance - IMPORTANT - Verify Your Account",
//             "VERIFY_ACCOUNT_INFO_DIV": "Don't have access to your email or want to validate with your policy number?",
//             "VERIFY_ACCOUNT_GO_TO_ADD_POLICY": "Verify using your policy details",
//             "NOT_FOUND": "Policy not found",
//             "NOTFOUND_POLICY_NOT_FOUND": "Information doesn't match with our records",
//             "POLICY_INFO_TITLE": "Policy information requested",
//             "POLICY_INFO_HOLDER_NAME": "Policyholder name",
//             "POLICY_INFO_NUMBER": "Policy number",
//             "EDIT_POLICY_INFO": "Edit Policy information",
//             "TRY_AGAIN": "Try Again",
//             "NOTFOUND_NEED_ASSISTANCE": "If you need personal assistance, contact our Customer Service Department",
//             "NOTFOUND_IF_YOU_PURCHASE": "If you purchased your policy in the last 2 days, it may still be processing. Sorry for the inconvenience!",
//             "TRY_AGAIN_WITH_A_DIFFERENT": "Try with another policy",
//             "EDIT_POLICY": "Edit policy info",
//             "EDITPOLICY_REVIEW_POLICY": "Review your policy information and confirm.",
//             "CONFIRM": "CONFIRM",
//             "POLICYBELONGS_TO_ANOTHER": "Policy Found",
//             "POLICYBELONGS_INFO_TITLE": "Verify that you own this policy",
//             "POLICYBELONGS_TYPE_NUMBER_PERSONAL": "Personal",
//             "POLICYBELONGS_TYPE_NUMBER_BIZ": "Business",
//             "POLICYBELONGS_TYPE_NUMBER_AUTO": "Auto",
//             "POLICYBELONGS_TYPE_NUMBER_HOME": "Home",
//             "EFFECTIVE_DATE": "Effective Date",
//             "POLICYBELONGS_LEGAL": "By clicking continue, you are confirming that you own the policy specified above or have been authorized by the policyholder to act on his or her behalf with respect to such policy.",
//             "POLICYBELONGS_AUTHORIZED": "Continue",
//             "REVIEW_POLICY_TITLE": "Welcome to your MAPFRE account",
//             "REVIEWPOLICY_INFO_TITLE": "Here is your policy information",
//             "REVIEWPOLICY_WALLETCARD": "Add your Mapfre card to your phone",
//             "VALID_NAME_VALIDATION_MESSAGE": "Please use a valid name",
//             "VALID_POLICY_VALIDATION_MESSAGE": "Please use a valid policy",
//             "CREATE_ACCOUNT_LEGAL_ONE": "By clicking CONTINUE, you are confirming that you have read and agree to our ",
//             "CREATE_ACCOUNT_LEGAL_TWO": "Terms & Conditions",
//             "CREATE_ACCOUNT_LEGAL_THREE": "and",
//             "CREATE_ACCOUNT_LEGAL_FOUR": "Privacy Policy",
//             "CAUTION_CREATE_ACCOUNT": "At this moment of time, an email cannot be 20 characters long.",

//             "SUCCESS_FORGOT_PASSWORD": "You have successfully changed your password.",
//             "BACK":"BACK",

//             "PASSWORD_RULE_ONE": "Be a mix of lowercase & uppercase letters",
//             "PASSWORD_RULE_TWO": "Have at least 1 number",
//             "PASSWORD_RULE_THREE": "Have at least 1 special character (like @,!,$)",
//             "PASSWORD_RULE_FOUR": "Be at least 7 characters long",
//             "PASSWORD_RULE_FIVE": "At the most 24 characters long"

//           }

//     },{
//         "identifier" : "ES",
//         "name" : "Spanish",
//         "sentences": {
//             "LOGIN": "Iniciar sesión",
//             "REGISTER": "Registro",
//             "CONF_PASS": "Confirmar contraseña",
//             "CANCEL": "Cancelar",
//             "SIGNUPTEXT": "Hacemos un gran seguro. ¿Podríamos cuidar de usted?",
//             "FOOTER_TEXT": "MAPFRE Insurance es una marca y servicio de MAPFRE U.S.A Corp. y sus filiales. Aprender acerca",
//             "OUR_COMPANIES": "Nuestras empresas",
//             "PRIVACY": "Política de privacidad",
//             "TERMS": "Términos y condiciones",
//             "QUOTE": "Cotización",
//             "CAREERS": "Empleo",
//             "CONTACT": "Contacto",
//             "RIGHTS": "MAPFRE U.S.A Corp. Todos los derechos reservados.",
//             "EMAIL_REQUIRED": "Correo electronico es obligatorio.",
//             "EMAIL_INVALID": "El correo electrónico es invalido.",
//             "PASSWORD_REQUIRED": "Contraseña obligatoria.",
//             "CONF_PASS_REQUIRED": "Confirmar contraseña es obligatorio.",
//             "PASSWORDS_NOT_MATCH": "La contraseña y la contraseña no coinciden.",
//             "FIRST_TIME": "Primera vez",
//             "SIGN_IN": "Iniciar sesion",
//             "CUSTOMER_ACCESS": "Acceso de clientes",
//             "REMEMBER_ME": "Recuérdame",
//             "FORGOT_PASS": "Recordar tu contraseña",
//             "CREATE_ACCOUNT": "Crear Cuenta",
//             "SHOW_PASSWORD": "Mostrar contraseña",
//             "HIDE_PASSWORD": "Ocultar contraseña",
//             "YOUR_PASSWORD_SHOULD_BE": "Su contraseña deberia ser",

//             "DOES_NOT_PASS": "no pasa",
//             "PASSES_THE_RULE": "pasa",
//             "INVALID_USERNAME_PASSWORD": "Inválido correo electrónico y/o contraseña",
//             "MODAL_HELP_TITLE": "Ayuda",
//             "MODAL_HELP_CUSTOMER_PORTAL": "Su cuenta MAPFRE le permite acceder a sus documentos de poliza, informar siniestros y realizar pagos en cualquier momento.",
//             "MODAL_HELP_TROUBLE_ACCESSING": "¿Tiene problemas para acceder a su cuenta?",
//             "MODAL_HELP_DONT_HESITATE": "No dude en ponerse en contacto con nuestro Departamento de Atención al Cliente.",
//             "MODAL_USER_LANGUAGE_TITLE": "IDIOMA",
//             "CALL_US": "Llámenos",
//             "EMAIL_US": "Envíanos un email",
//             "FOOTER_DEFAULT_LANGUAGE": "ESPAÑOL",
//             "FOOTER_COPY_RIGHT" : "MAPFRE U.S.A Corp. Todos los derechos reservados.",
//             "FORGOT_PASSWORD_TITLE": "Olvidaste tu contraseña",
//             "FORGOT_PASSWORD_PARAGRAPH": "Le enviaremos un correo electrónico con instrucciones",
//             "FORGOT_PASSWORD_SUBMIT_BUTTON": "Pide nueva contraseña",
//             "CHECK_YOUR_EMAIL_TITLE" : "Consulte su correo electrónico",
//             "CHECK_YOUR_EMAIL_PARAGRAPH" : "Le hemos enviado un correo electrónico con instrucciones sobre cómo crear una nueva contraseña",
//             "EMAIL": "Correo Electrónico",
//             "PASSWORD": "Contraseña",
//             "VALID_EMAIL_VALIDATION_MESSAGE" : "Por favor introduzca una dirección de correo electrónico válida",
//             "EMAIL_COULD_NOT_VALIDATE": "No pudimos validar su correo electrónico",
//             "INVALID_EMAIL_PASSWORD": "Correo electrónico / contraseña inválidos",
//             "CAPS_LOCK" : "Bloqueo de mayúsculas activo",
//             "FORGOT_EMAIL_CONFIMATION_SUBTITLE": "¿No recibió el correo electrónico?",
//             "FORGOT_EMAIL_CONFIMATION_COPY": "Revisa tu correo no deseado por un mensaje de ",
//             "FORGOT_PASS_EMAIL_SUBJECT": "MAPFRE Insurance - IMPORTANT - Reset your password",
//             "FORGOT_EMAIL_SEND_AGAIN": "Enviar correo nuevo",
//             "FORGOT_EMAIL_REVIEW_ME": "Por favor revise",
//             "CREATE_PASSWORD": "Escriba su nueva contraseña",
//             "CREATE_NEW_PASSWORD": "Crear nueva contraseña",
//             "VALID_PASSWORD_VALIDATION_MESSAGE": "",
//             "PASSWORD_RESET_CONFIRMATION_PARGRAPH": "Su contraseña fue restablecida",
//             "PASSWORD_RESET_CONFIRMATION_TITLE": "Confirmación",
//             "LINK_HAS_EXPIRED": "El link ha expirado",
//             "LINK_HAS_EXPIRED_PARAGRAPH": "Por razones de seguridad, estos enlaces caducan después de 48 horas.",
//             "REQUEST_NEW_LINK": "Solicitar un nuevo enlace",
//             "TOO_MANY_ATTEMPTS_TITLE": "Demasiados intentos",
//             "TOO_MANY_ATTEMPTS_PARAGRAPH": "Has alcanzado el máximo de intentos para ese correo electrónico. Por razones de seguridad, hemos bloqueado ese correo electrónico para continuar con esta acción para la próxima",
//             "TIME": "24 horas",

//             "FIRST_NAME": "Nombre de pila",
//             "MIDDLE_INITIAL": "MI",
//             "LAST_NAME": "Apellido",
//             "CONTINUE": "Continuar",
//             "ALL_READY_IN_USE": "ya está en uso",
//             "IF_YOU_DONT_REMEMBER": "Si no recuerda haber creado una cuenta, comuníquese con nuestro Departamento de Atención al Cliente",
//             "NEW_PASSWORD": "Establecer nueva contraseña",
//             "ADD_POLICY_TITLE": "Encontremos su política",
//             "POLICY_NUMBER": "Ingrese número de póliza",
//             "I_AM_THE_POLICY_HOLDER": "Soy el titular de la póliza o una persona autorizada",
//             "ADD_POLICY": "Agregar política",
//             "MODAL_WHERE_CAN_I_LINK": "¿Dónde puedo encontrar mi número de póliza?",
//             "MODAL_WHERE_CAN_I_TITLE": "Ubique su número de póliza",
//             "POLICY_DOCUMENT": "Documento de política",
//             "BILLING_DOCUMENT": "Factura de facturación",
//             "BOP": "Política comercial detectada",
//             "SERVICE_NOT_AVAILABLE": "Este servicio no está disponible en este momento.",
//             "BOP_POLICIES_CANNOT_BE_ACCESS_VIA_CUSTOMER_PORTAL": "Actualmente, no se puede acceder a las políticas comerciales a través del Portal del cliente.",
//             "VERIFY_ACCOUNT_TITLE": "Verifiquemos su cuenta",
//             "VERIFY_ACCOUNT_WE_SENT_AN_EMAIL": "Enviamos un correo electrónico con un enlace de verificación a:",
//             "VERIFY_ACCOUNT_SUBJECT_LINE": "Mapfre Insurance - IMPORTANT - Verify Your Account",
//             "VERIFY_ACCOUNT_INFO_DIV": "¿No tiene acceso a su correo electrónico o quiere validar con su número de póliza?",
//             "VERIFY_ACCOUNT_GO_TO_ADD_POLICY": "Verificar usando los detalles de su política",
//             "NOT_FOUND": "Política no encontrada",
//             "NOTFOUND_POLICY_NOT_FOUND": "La información no coincide con nuestros registros",
//             "POLICY_INFO_TITLE": "Información de política solicitada",
//             "POLICY_INFO_HOLDER_NAME": "Nombre del asegurado",
//             "POLICY_INFO_NUMBER": "Número de póliza",
//             "EDIT_POLICY_INFO": "Editar información de política",
//             "TRY_AGAIN": "Inténtalo de nuevo",
//             "NOTFOUND_NEED_ASSISTANCE": "Si necesita asistencia personal, comuníquese con nuestro Departamento de Atención al Cliente",
//             "NOTFOUND_IF_YOU_PURCHASE": "Si compró su póliza en los últimos 2 días, aún puede estar procesando. ¡Lo siento por los inconvenientes ocasionados!",
//             "TRY_AGAIN_WITH_A_DIFFERENT": "Prueba con otra política",
//             "EDIT_POLICY": "Editar información de política",
//             "EDITPOLICY_REVIEW_POLICY": "Revise la información de su póliza y confirme.",
//             "CONFIRM": "CONFIRMAR",
//             "POLICYBELONGS_TO_ANOTHER": "Política encontrada",
//             "POLICYBELONGS_INFO_TITLE": "Verifica que eres el propietario de esta política",
//             "POLICYBELONGS_TYPE_NUMBER_PERSONAL": "Personal",
//             "POLICYBELONGS_TYPE_NUMBER_BIZ": "Negocio",
//             "AUTO": "Auto",
//             "HOME": "Casa",
//             "EFFECTIVE_DATE": "Fecha efectiva",
//             "POLICYBELONGS_LEGAL": "Al hacer clic en continuar, confirma que posee la política especificada anteriormente o que el titular de la póliza le ha autorizado a actuar en su nombre con respecto a dicha política.",
//             "POLICYBELONGS_AUTHORIZED": "Continuar",
//             "REVIEW_POLICY_TITLE": "Bienvenido a su cuenta MAPFRE",
//             "REVIEWPOLICY_INFO_TITLE": "Aquí está su información de política",
//             "REVIEWPOLICY_WALLETCARD": "Agregue su tarjeta Mapfre a su teléfono",
//             "VALID_NAME_VALIDATION_MESSAGE": "Por favor usa un nombre válido",
//             "VALID_POLICY_VALIDATION_MESSAGE": "Por favor use una política válida",
//             "CREATE_ACCOUNT_LEGAL_ONE": "Al hacer clic en CONTINUAR, confirma que ha leído y acepta nuestros ",
//             "CREATE_ACCOUNT_LEGAL_TWO": "Términos y Condiciones",
//             "CREATE_ACCOUNT_LEGAL_THREE": "y nuestra",
//             "CREATE_ACCOUNT_LEGAL_FOUR": "Política de Privacidad.",
//             "CAUTION_CREATE_ACCOUNT": "En este momento, un correo electrónico no puede tener 20 caracteres.",
//             "SUCCESS_FORGOT_PASSWORD": "Has cambiado satisfactoriamente tu contraseña.",
//             "BACK":"espalda",

//             "PASSWORD_RULE_ONE": "Ser una mezcla de letras minúsculas y mayúsculas",
//             "PASSWORD_RULE_TWO": "Tener al menos 1 número",
//             "PASSWORD_RULE_THREE": "Tener al menos 1 personaje especial (como @,!, $)",
//             "PASSWORD_RULE_FOUR": "Tener al menos 7 caracteres de largo",
//             "PASSWORD_RULE_FIVE": "A lo sumo 24 caracteres de largo"

//           }
//     }];
// }

import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
declare let require: any;
const english = require("../../assets/language/english/english.json");
const spanish = require("../../assets/language/spanish/spanish.json");
const waEnglish = require("../../assets/language/wa/english.json");
const waSpanish = require("../../assets/language/wa/spanish.json");
const acmicEnglish = require("../../assets/language/acmic/english.json");
const acmicSpanish = require("../../assets/language/acmic/spanish.json");
const idEnglish = require("../../assets/language/id/english.json");
const idSpanish = require("../../assets/language/id/spanish.json");

@Injectable()
export class Language {
  constructor(public translate: TranslateService) {}

  public lang = {
    MA: [
      {
        identifier: "EN",
        name: "English",
        sentences: english
      },
      {
        identifier: "ES",
        name: "Spanish",
        sentences: spanish
      }
    ],
    WA: [
      {
        identifier: "EN",
        name: "English",
        sentences: waEnglish
      },
      {
        identifier: "ES",
        name: "Spanish",
        sentences: waSpanish
      }
    ],
    ACMIC: [
      {
        identifier: "EN",
        name: "English",
        sentences: acmicEnglish
      },
      {
        identifier: "ES",
        name: "Spanish",
        sentences: acmicSpanish
      }
    ],
    ID: [
      {
        identifier: "EN",
        name: "English",
        sentences: idEnglish
      },
      {
        identifier: "ES",
        name: "Spanish",
        sentences: idSpanish
      }
    ]
  };

  setLang(lang: string): void {
    this.translate.use(lang);
  }

}
